import {Theme} from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          boxShadow: theme.customShadows.card,
          border: `1px solid ${theme.palette.divider}`, // Added subtle border for modern structured look
          borderRadius: Number(theme.shape.borderRadius) * 1.5, // Refined scaling
          zIndex: 0, // Fix Safari overflow: hidden with border radius
          transition: 'box-shadow 0.3s ease-in-out',
          '&:hover': {
            boxShadow: theme.customShadows.z12 // Slight lift on interactions
          }
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {variant: 'h6'},
        subheaderTypographyProps: {
          variant: 'body2',
          marginTop: theme.spacing(0.5)
        }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3)
        }
      }
    }
  }
}
